import neonStyles from "./neon.module.scss";

export type TNeon = {
  color: "light-blue" | "green" | "default";
};

export const Neon = ({ color }: TNeon): JSX.Element => {
  return (
    <div className={neonStyles["new-neon"]}>
      <div className={`${color}`}></div>
      <div
        className={`${neonStyles["neon-circle-2"]} ${neonStyles[color]}`}></div>
      <div
        className={`${neonStyles["neon-circle-3"]} ${neonStyles[color]}`}></div>
      <div className={`${neonStyles["neon-glow"]} ${neonStyles[color]}`}></div>
      <div
        className={`${neonStyles["neon-glow-2"]} ${neonStyles[color]}`}></div>
      <div
        className={`${neonStyles["neon-inner-bg"]} ${neonStyles[color]}`}></div>
    </div>
  );
};
